import { Link } from 'react-router-dom';
import { STAGE_CONFIG } from './stageConfig';

const MARKER_ICON = {
    ok: '✓',
    warning: '!',
    attention: '!',
    critical: '✕',
    no_data: '?',
    not_available: '···',
};

const WARNING_ICON = {
    high: '⚖️',
    medium: '⚠️',
    low: '💡',
};

export default function StageCard({ stage, routeParams, isFirstOpenIssue }) {
    const config = STAGE_CONFIG[stage.key] || {};
    const route = config.getRoute ? config.getRoute(routeParams) : null;
    const isNotAvailable = stage.status === 'not_available';

    return (
        <div className="audit-timeline-item">
            <div className={`audit-timeline-marker audit-timeline-marker--${stage.status}${isFirstOpenIssue ? ' audit-timeline-marker--current' : ''}`}>
                {isFirstOpenIssue && <span className="audit-timeline-marker-ring" />}
                <span className="audit-timeline-marker-node">{MARKER_ICON[stage.status] || '?'}</span>
            </div>

            <div className={`audit-stage-card audit-stage-card--${stage.status}`}>
                <div className="audit-stage-card-header">
                    <div className="audit-stage-card-title-group">
                        <span className="audit-stage-card-step-label">Étape {stage.stage}</span>
                    </div>
                    {isNotAvailable ? (
                        <span className="audit-stage-card-percent audit-stage-card-percent--not-available">À venir</span>
                    ) : stage.percent !== null ? (
                        <span className="audit-stage-card-percent">{stage.percent}%</span>
                    ) : null}
                </div>

                <div className="audit-stage-card-label">{stage.label}</div>

                {stage.counts && Object.keys(stage.counts).length > 0 && (
                    <div className="audit-stage-card-counts">
                        {Object.entries(stage.counts).map(([key, value]) => (
                            value !== null && value !== undefined && (
                                <span key={key} className="audit-stage-card-chip">{formatCountLabel(key, value)}</span>
                            )
                        ))}
                    </div>
                )}

                {stage.warnings && stage.warnings.length > 0 && (
                    <ul className="audit-stage-card-warnings">
                        {stage.warnings.map((warning, i) => (
                            <li key={i} className={`audit-stage-card-warning audit-stage-card-warning--${warning.severity}`}>
                                <span className="audit-stage-card-warning-icon">{WARNING_ICON[warning.severity] || '⚠️'}</span>
                                <span>{warning.message}</span>
                            </li>
                        ))}
                    </ul>
                )}

                {config.tutorial && (
                    <div className="audit-stage-card-tutorial">
                        <span className="audit-stage-card-tutorial-icon">💡</span>
                        <p className="audit-stage-card-tutorial-text">{config.tutorial}</p>
                    </div>
                )}

                {route && config.ctaLabel && (
                    <Link className="audit-stage-card-cta" to={route}>{config.ctaLabel} →</Link>
                )}
            </div>
        </div>
    );
}

const COUNT_LABELS = {
    critical_filled: 'champs critiques renseignés',
    critical_total: 'champs critiques',
    recommended_filled: 'champs recommandés renseignés',
    recommended_total: 'champs recommandés',
    sections: 'sections',
    rooms: 'pièces',
    equipments: 'équipements',
    equipments_total: 'équipements',
    equipments_without_photo: 'sans photo',
    rooms_without_equipment: 'pièces sans équipement',
    equipments_missing_technical_data: 'infos techniques manquantes',
    categories_total: "catégories d'usagers",
    categories_complete: 'catégories complètes',
    equipments_zero_usages: 'sans usage',
    sanitary_zero_usages: 'sanitaires sans usage',
    other_zero_usages: 'autres équipements sans usage',
    no_rating: 'sans note',
    estimated: 'estimée (m³)',
    real: 'réelle (m³)',
};

function formatCountLabel(key, value) {
    const label = COUNT_LABELS[key] || key;
    const formattedValue = typeof value === 'number' ? Math.round(value * 100) / 100 : value;
    return `${formattedValue} ${label}`;
}
